export default __webpack_public_path__ + "static/1_11-6566f410e100845e8096915a2d7e32b2.png";